export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-regular-310b378be517b7c5ec973f1abec40708.woff";